import { Component, Input } from '@angular/core';

@Component({
  selector: 'acan-field',
  templateUrl: './acan-field.component.html',
  styleUrls: ['./acan-field.component.scss'],
  standalone: false,
})
export class AcanFieldComponent {
  @Input() label = '';
  @Input() required = false;
  @Input() error?: string;
}
